<ng-container *ngIf="templateReplaySubject | async">
    <ng-container *ngTemplateOutlet="templateReplaySubject | async"></ng-container>
</ng-container>
